import makeStyles from '@mui/styles/makeStyles';
import { get } from 'global/lib/lodash';
import colors from 'global/styles/colors';

const IMAGE = 100;

const useStyles = makeStyles((theme) => ({
  alertTemplate: {
    '& .MuiAlert-message': {
      width: '100%',
      alignItems: 'center',
    },
  },
  templateButtonContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    '& button': {
      marginRight: theme.spacing(1),
    },
  },
  templateContainer: {
    '& h2': {
      fontWeight: 'bold',
      fontSize: 20,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    '& .systemIcon': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing(2),

      '& .MuiSvgIcon-root': {
        borderRadius: 20,
        padding: 5,
        backgroundColor: colors.black,
        color: colors.white,
        marginRight: theme.spacing(1),
      },
    },
    '& .textContainer': {
      marginTop: theme.spacing(4),
    },
    '& .textDivider': {
      width: '100%',
      clear: 'both',
      fontSize: 13,
      marginBottom: theme.spacing(2),

      '& .left': {
        width: '50%',
        boxSizing: 'border-box',

        '& .leftTitle': {
          fontWeight: 'bold',
        },
      },
      '& .right': {
        boxSizing: 'border-box',
        width: '50%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',

        '& .IMAGE': {
          marginRight: 2,
          marginBottom: 2,
        },
      },
    },
  },

  dialog: {
    zIndex: `1000 !important`,
    overflowY: 'hidden',

    '& .MuiDialog-paperScrollPaper, .MuiDialog-scrollPaper': {
      overflowY: 'hidden',
    },
  },
  appBar: {
    position: 'relative',
  },
  toolbar: {
    height: 70,
  },
  title: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
  },
  subTitle: {
    fontSize: 15,
  },
  status: {
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    display: 'flex',
  },
  statusIcon: {
    marginLeft: theme.spacing(2),
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '80%',
    maxWidth: 650,
    margin: '0 auto',
  },
  barTitle: {
    flexDirection: 'column',
    flex: 1,
    marginLeft: theme.spacing(2),
  },

  buttonContainer: {
    margin: theme.spacing(1),
  },
  tagButton: {
    color: theme.colors.blue,
    borderColor: theme.colors.blue,
  },
  tagRemove: {
    color: theme.colors.danger,
    borderColor: theme.colors.danger,
  },
  tagContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  tagText: {
    fontSize: 14,
  },
  tagOption: {},
  tagBox: {
    margin: 4,

    '& .MuiSvgIcon-root': {
      marginBottom: -7,
    },
  },
  tagName: {
    fontWeight: 'bold',
    marginRight: theme.spacing(1),
  },
  tagDescription: {},
  tagLink: {
    marginBottom: theme.spacing(1),
  },

  formStyle: {
    // alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
    display: 'block',

    '& .MuiFormControl-root': {
      paddingTop: 0,
    },
  },
  titleStyle: {
    fontSize: '18px !important',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  screenWidth: {
    width: '100%',
    '& .MuiInput-formControl.Mui-disabled, .MuiInputLabel-formControl': {
      color: theme.palette.text.primary,
    },
    '& .Mui-disabled.MuiInputBase-formControl .MuiSelect-icon': {
      display: 'none',
    },
    '& .Mui-disabled.MuiInput-underline:before': {
      border: `none !important`,
    },
  },
  screenContainer: {
    maxWidth: 'none !important',
  },
  screenContainerMobile: {
    maxWidth: 'none !important',
  },

  dropZone: {
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    borderRadius: 10,
    width: 'auto',
  },
  imageWrap: {
    position: 'relative',
    margin: theme.spacing(1),
    width: IMAGE,
  },
  image: {},
  imageDelete: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  comment: {
    padding: `0 ${theme.spacing(1)}`,
    backgroundColor: (props) => (get(props, 'formState.overwritten') ? 'white' : theme.palette.action.disabled),

    '& .MuiInput-underline:before, .MuiInput-underline:after': {
      border: 'none !important',
    },
    '& textarea': {
      margin: theme.spacing(1),
    },
    '& .MuiFormHelperText-root': {
      position: 'relative',
      bottom: -20,
    },
  },

  submitButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),

    '& button': {
      marginLeft: theme.spacing(2),
    },
  },
  doubleIcon: {
    position: 'relative',
    height: 24,
  },
  plusIcon: {
    position: 'absolute',
    top: 12,
    right: -2,
    fontSize: 14,
  },
  submitBtnText: {
    maxWidth: 90,
  },
}));

export default useStyles;
